export const textItems = {
	close: 'Afsluiten',
	closeAndContinue: 'Sluiten en verdergaan',
	closeAndRestart: 'Sluiten en opnieuw beginnen',
	start: 'Start',
	resumeLater: 'Later verdergaan',
	resumeLaterClarification:
		'Sla onderstaande code op, zodat u deze op een later moment weer kunt invoeren om verder te gaan met de vragenlijst waar u gebleven was. Dat kan vanaf elk apparaat.',
	next: 'Volgende',
	previous: 'Vorige',
	resume: 'Verdergaan',
	clarification: 'Toelichting',
	clarificationLoading: 'Toelichting wordt geladen...',
	getQuestionaire: 'Vragenlijst ophalen',
	getQuestionaireByCode: 'Vragenlijst ophalen met code',
	getQuestionaireByCodeClarification: 'Vul hier uw code in om verder te gaan met de vragenlijst.',
	getQuestionaireByCodeErrorCodeRequired: 'U heeft geen code ingevuld',
	getQuestionaireByCodeErrorInvalidLength:
		'De door u ingevulde code heeft niet het juiste aantal tekens. De code moet 12 tekens lang zijn',
	getQuestionaireByCodeErrorInvalid: 'Ongeldige invoer',
	errorTitle: 'Er is iets mis gegaan',
	errorClarification: `Probeer het later nog eens. Als het probleem zich blijft voordoen, neem dan contact op met
	<a href="mailto:webmodule@minszw.nl">webmodule@minszw.nl</a>`,
	resumeDialogTitle: 'Vragenlijst verdergaan waar u gebleven was?',
	resumeDialogClarification:
		'Er is een vragenlijst gevonden waar u mee bezig was, wilt u met deze vragenlijst verdergaan?',
	restart: 'Opnieuw beginnen',
	print: 'Printen',
	toReport: 'Naar resultaten',
	icons: {
		close: 'Venster sluiten',
		warning: 'Fout',
		loading: 'Laden',
		next: 'Volgende vraag',
		previous: 'Vorige vraag',
		print: 'Afdrukken',
		document: 'Document',
	},
};
